const StringificationPattern = {
    XYZ: { key: 'XYZ', name: '3D point saved as X, Y, Z coordinates', pattern: ['X', 'Y', 'Z'] },
    QuarticPolynomialX: { key: 'QuarticPolynomialX' , name: 'Fourth degree polynomial for X coordinate', pattern: ['X4', 'X3', 'X2', 'X1', 'X0'] },
    QuarticPolynomialY: { key: 'QuarticPolynomialY' , name: 'Fourth degree polynomial for Y coordinate', pattern: ['Y4', 'Y3', 'Y2', 'Y1', 'Y0'] },
    QuarticPolynomialZ: { key: 'QuarticPolynomialZ' , name: 'Fourth degree polynomial for Z coordinate', pattern: ['Z4', 'Z3', 'Z2', 'Z1', 'Z0'] },
    QuarticPolynomial: { key: 'QuarticPolynomial' , name: 'Fourth degree polynomial', pattern: ['C4', 'C3', 'C2', 'C1', 'C0'] },
};

export default StringificationPattern;